module.exports = __webpack_public_path__ + "img/pic1@2x.c51916c5.png";